import React from "react";
import { TableHead } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SortableTableHeader } from "@components";

interface Props {
  sortField?: string;
  sortDirection?: TableSortDirection;
  sort: (sortField: string) => void;
}

export const DepotsRowHeadings = ({
  sortField,
  sortDirection,
  sort,
}: Props) => {
  const { t } = useTranslation();

  const commonProps = {
    sortField,
    sortDirection,
    isSortable: true,
    onClick: sort,
  };

  return (
    <TableHead>
      <SortableTableHeader
        text={t("csvImport.parsingResults.date")}
        sortByName="date.value"
        {...commonProps}
      />
      <SortableTableHeader
        text={t("csvImport.parsingResults.name")}
        sortByName="name.value"
        {...commonProps}
      />
      <SortableTableHeader
        text={t("csvImport.parsingResults.number_of_lots")}
        sortByName="number_of_lots.value"
        {...commonProps}
        align="right"
      />
      <SortableTableHeader
        text={t("csvImport.parsingResults.security_price")}
        sortByName="security_price.value"
        {...commonProps}
        align="right"
      />
      <SortableTableHeader
        text={t("csvImport.parsingResults.commission")}
        sortByName="commission.value"
        {...commonProps}
        align="right"
      />
      <SortableTableHeader
        text={t("csvImport.parsingResults.tax_amount")}
        sortByName="tax_amount.value"
        {...commonProps}
        align="right"
      />
      <SortableTableHeader text="" sortByName="" />
    </TableHead>
  );
};
